import React from 'react'
import RecordHeading from '../../ui/record-heading'
import RecordDisplay from '../../ui/record-display'
import LocalASyncStore from '../../local-async-store'
import CaseClaim from './case-claim'

const level1 = [
  {
    key: 'Type',
    label: 'Type',
  },
  {
    key: 'Status',
    label: 'Status',
  },
  {
    key: 'StartDate',
    label: 'Start Date',
  },
  {
    key: 'EndDate',
    label: 'End Date',
  },
  {
    key: 'ApprovalId',
    label: 'Approval ID',
  },
  {
    key: 'CareProvision',
    label: 'Care Provision',
  },
]

const level2 = [
  {
    key: 'ISNonFaceToFaceHrsBalance',
    label: 'Non Face To Face Hrs Balance',
  },
  {
    key: 'IPFirstName',
    label: 'IP First Name',
  },
  {
    key: 'IPLastName',
    label: 'IP Last Name',
  },
]

const ISSCaseClaimDetail = gov_rego => ({ record, iss_case_claim, refresh_iss_case_claim }) => (
  <div>
    <RecordHeading record={{ first_name: 'ISS Case', last_name: record.gov_id }} />
    <RecordDisplay level1={level1} level2={level2} showRaw record={record.gov_record} />
    <CaseClaim
      iss_case_claim={iss_case_claim}
      refresh_iss_case_claim={() => refresh_iss_case_claim(gov_rego.api({ record }))}
      iss_case={record}
      gov_rego={gov_rego}
    />
  </div>
)

const apiEndPont = ({ record_type, record_id, start_date }) => ({ record }) =>
  ['/api', record_type, record_id, 'iss-cases', record.gov_id, 'iss-case-claims', start_date].join(
    '/'
  )

export default ({ record_type, record_id, start_date }) => {
  const api = apiEndPont({ record_type, record_id, start_date })

  return LocalASyncStore(
    'iss_case_claim',
    ISSCaseClaimDetail({ record_type, record_id, start_date, api }),
    api
  )
}



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/index.jsx